import { FC } from 'react';
import { ReportSubtype } from '../../models/Report';
import { Button } from 'primereact/button';
import { useAppSelector } from '../../redux/hooks';
import { selectedReportHubQuerysInProgress } from '../../redux/reducers/reportHubQuerysInProgress';

interface Props {
  cardHeader: string;
  cardSummary: string;
  reportSubtype: ReportSubtype;
  setVisibleGenerateDialog: (visible: boolean) => void;
  setSelectedReportSubtype: (reportSubtype: ReportSubtype | null) => void;
}

const getButtonID = (reportSubtype: ReportSubtype, buttonType: string) => {
  switch (reportSubtype) {
    case ReportSubtype.DIAGNOSTIC_SUMMARY:
      return buttonType === 'viewExample' ? 'viewDiagnosticSummary' : 'genDiagnosticSummary';
    case ReportSubtype.DIAGNOSTIC_STUDENTS_UNFINISHED_DIAGNOSTIC:
      return buttonType === 'viewExample' ? 'viewStudentsUnfinishedDiagnostics' : 'genStudentsUnfinishedDiagnostics';
    case ReportSubtype.PROGRESS_DETAILED_SKILL_REPORT:
      return buttonType === 'viewExample' ? 'viewDetailedSkillReport' : 'genDetailedSkillReport';
    case ReportSubtype.PROGRESS_SKILL_ASSESSMENT_HISTORY:
      return buttonType === 'viewExample' ? 'viewSkillAssessmentHistory' : 'genSkillAssessmentHistory';
  }
};

const ExportCard: FC<Props> = ({
  cardHeader,
  cardSummary,
  reportSubtype,
  setVisibleGenerateDialog,
  setSelectedReportSubtype,
}) => {
  const reportHubQuerysInProgressRedux = useAppSelector(selectedReportHubQuerysInProgress);

  return (
    <div className="flex flex-column border-300 border-2 border-round-xl md:col-6 surface-0 p-4 m-1 justify-content-between">
      <div>
        <div className="flex justify-content-between align-items-center">
          <h1 className="md:text-lg font-semibold line-height-3 text-base">{cardHeader}</h1>
        </div>
        <p style={{ fontFamily: 'Poppins' }}>{cardSummary}</p>
      </div>
      <div className="flex flex-column sm:flex-row row-gap-2 sm:row-gap-0 justify-content-end align-items-center">
        <Button
          id={getButtonID(reportSubtype, 'generalReport')}
          label="Generate Report"
          outlined
          disabled={reportHubQuerysInProgressRedux}
          onClick={() => {
            setSelectedReportSubtype(reportSubtype);
            setVisibleGenerateDialog(true);
          }}
        />
      </div>
    </div>
  );
};

export default ExportCard;
